/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScorePewsListAliases {
  ADD_SCORE_PEWS_CUSTOM_DYNAMIC_BUTTON = 'add-score-pews-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_PEWS = 'deck-score-pews',
  FETCH_SCORE_PEWS_LIST = 'fetch-score-pews-list',
  FILTERED_LIST_SCORE_PEWS = 'filtered-list-score-pews',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_PEWS_LIST = 'layout-score-pews-list',
  LEGENDES_SCORE_PEWS = 'legendes-score-pews',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_AND_INDEXES_CARD_0 = 'scores-and-indexes-card-0',
}
export { ScorePewsListAliases };
